import React, { useState, useEffect, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import styled from 'styled-components';
import { Form, Formik, Field } from 'formik';
import {
    getPostInitialValues,
    VALIDATION_SCHEMA,
} from 'web/components/utils/cancelOrderUtils';
import Button from 'web/components/Button';
import {
    acceptAndReject,
    repostAndScheduledOrder,
    cancelSellerBuyerOrder
} from 'redux/actions/myOrders';
import DatePicker from 'web/components/form-elements/DatePicker';
import TimePicker from 'web/components/form-elements/TimePicker';
import { FORMAT, BIDFORMAT } from 'web/components/utils/dateOfBirthValidation';
import CheckIcon from 'web/assets/svg/CheckIcon';
import CancelOrderPopup from '../CancelOrderPopup';
import AlertModal from 'web/components/AlertModal';
import { TrackDetail, Panding, TrackBox, TrackDescription, Icon, Msg } from './trackDetailTypeCancelStyled'
import { fetchLanguageContentNew } from 'redux/actions/language';

const TrackDetailTypeCancel = ({ items, orderType, callBackFun, canceledOrderCallBack }) => {

    let history = useHistory();
    const dispatch = useDispatch();
    const token = localStorage.getItem('token');
    const [cancelOrderId, setCancelOrderId] = useState()
    const [cancelOrderModal, setCancelOrderModal] = useState(false);
    const cancelOrderToggleModal = () => setCancelOrderModal(!cancelOrderModal);

    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('/');
    const toggleModal = () => setModal(!modal);

    const currentLanguage = useSelector(state => state.language.currentLanguage)
    const languageContentNew = useSelector(state => state.language.languageContentNew)
    const [pageLanguageContents, setPageLanguageContents] = useState()
    const [statusArr, setStatusArr] = useState([])

    useEffect(() => {
        if (languageContentNew?.My_Orders_Page) setPageLanguageContents(languageContentNew.My_Orders_Page)
        else dispatch(fetchLanguageContentNew(currentLanguage))
    }, [languageContentNew])

    useEffect(() => {
        setStatusArr([pageLanguageContents?.DetailedContents[13]?.Shipped,
        pageLanguageContents?.DetailedContents[16]?.Delivered])
    }, [pageLanguageContents])

    let title = '';

    const orderTabs = (index) => {
        return <>
            {index === 0 && <div>
                <Icon><CheckIcon color="#979797" /></Icon>
                <h3>{statusArr[0]}</h3>
                <div>
                    <Panding>Pending</Panding>
                </div>
            </div>}
            {index === 1 && <div>
                <Icon><CheckIcon color="#979797" /></Icon>
                <h3>{statusArr[1]}</h3>
                <div>
                    <Panding>Pending</Panding>
                </div>
            </div>}
        </>
    }

    const [dateTimeFlag, setDateTimeFlag] = useState(false)

    const dateTimeFun = () => {
        return <>{dateTimeFlag && <Formik
            initialValues={getPostInitialValues()}
            validationSchema={VALIDATION_SCHEMA()}
            onSubmit={(values) => {
            }}>
            {(props) => {
                const {
                    isValid,
                    dirty,
                    values,
                    errors,
                    touched,
                    setFieldValue,
                } = props;

                return (
                    <>
                        <Form>
                            <div className='row mx-0 my-3'>
                                <div className='col-12'>

                                    <div className='row'>
                                        <div className='col-md-6 col-sm-6'>
                                            <DatePicker
                                                name='cancelDate'
                                                placeholderText={pageLanguageContents?.DetailedContents[27]?.BidCloseTime}
                                            />
                                        </div>
                                        <div className='col-md-6 col-sm-6'>
                                            <TimePicker
                                                name='cancelTime'
                                                type='time'
                                                showErrorMessages={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Button

                                type='app-green-button submitBtn'
                                handleClick={() => {
                                    callBackFun(items.id, "RESCHEDULE", props)
                                }}
                            >
                                {pageLanguageContents?.DetailedContents[28]?.Done}
                            </Button></div>
                        </Form>
                    </>
                );
            }}
        </Formik>}</>
    }

    const actionView = () => {
        return <>
            {items.rePost && items.rePost.rePostStatus === "REPOSTED" ? <Msg>{pageLanguageContents?.DetailedContents[29]?.Alert6}</Msg> : <>
                <Msg>{pageLanguageContents?.DetailedContents[30]?.Alert7}</Msg>
                <TrackDescription>
                    <Button
                        type='app-green-button'
                        handleClick={() => {
                            callBackFun(items.id, "ACCEPTED")
                        }}>
                        {pageLanguageContents?.DetailedContents[19]?.Accept}
                    </Button>
                    <Button
                        type='app-green-button'
                        handleClick={() => {
                            callBackFun(items.id, "REJECTED", "Cancel")
                        }}>
                        {pageLanguageContents?.DetailedContents[20]?.Reject}
                    </Button>
                </TrackDescription>
            </>}
        </>
    }
    return (
        <>
            {items.orderStatus !== "COMPLETE" && <>
                {items.rePost && items.rePost.rePostStatus === "REPOSTED" ? <TrackDetail><TrackBox><Msg>{pageLanguageContents?.DetailedContents[29]?.Alert6}</Msg> </TrackBox></TrackDetail> : <TrackDetail>
                    {items.orderCancelDetails && items.orderCancelDetails.canceledUserType === "BUYER" && items.rePost && items.rePost.rePostStatus === "PENDING" && items.rePost.userType === "SELLER" && items.userType === "SELLER" && items.orderDetails.postType === "INVENTORY" ?
                        <TrackBox>
                            {actionView()}
                        </TrackBox>
                        : <>
                            {items.orderCancelDetails && items.orderCancelDetails.canceledUserType === "SELLER" && items.rePost && items.rePost.rePostStatus === "PENDING" && items.rePost.userType === "BUYER" && items.userType === "BUYER" && items.orderDetails.postType === "LOAD" ?
                                <TrackBox>
                                    {actionView()}
                                </TrackBox>
                                : <TrackBox>
                                    {items.orderStatus === "CANCELLED" && !items.rescheduleOrder ? <Msg></Msg>
                                        : <>
                                            {items.rePost && items.rePost.rePostStatus === "PENDING" && items.userType === "SELLER" && items.rePost.userType === "SELLER" && items.orderDetails.postType === "INVENTORY" ?
                                                actionView() : <>
                                                    {items.rePost && items.rePost.rePostStatus === "PENDING" && items.userType === "BUYER" && items.rePost.userType === "BUYER" && items.orderDetails.postType === "LOAD" ?
                                                        actionView() : <Msg>{pageLanguageContents?.DetailedContents[31]?.Alert8}</Msg>
                                                    }
                                                </>
                                            }
                                        </>
                                    }
                                </TrackBox>
                            }
                        </>
                    }
                </TrackDetail>}
            </>}
            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title={title}
                content={modalContent}
                link={modalLink}
            />
        </>
    )
};

export default TrackDetailTypeCancel;

const TrackStatus = styled.div`
    font-size: 15px;
    font-weight:bold;
    flex: unset !important;
`